import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import getAPIbaseURL from "../../utils/helpers";

const API_URL = `${getAPIbaseURL()}/statistics`;

export const createStatistics = createAsyncThunk(
  "statistics/createStatistics",
  async (statisticsData, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(`${API_URL}/`, statisticsData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error creating statistics");
    }
  }
);

export const fetchStatisticsByUser = createAsyncThunk(
  "statistics/fetchStatisticsByUser",
  async (userId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error fetching statistics");
    }
  }
);

export const fetchExtendedStatisticsByUser = createAsyncThunk(
  "statistics/fetchExtendedStatisticsByUser",
  async (userId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${API_URL}/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Error fetching extended statistics"
      );
    }
  }
);

export const updateStatistics = createAsyncThunk(
  "statistics/updateStatistics",
  async ({ userId, updates }, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(`${API_URL}/${userId}`, updates, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error updating statistics");
    }
  }
);

export const deleteStatistics = createAsyncThunk(
  "statistics/deleteStatistics",
  async (userId, thunkAPI) => {
    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${API_URL}/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return userId;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error deleting statistics");
    }
  }
);

const statisticsSlice = createSlice({
  name: "statistics",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    message: null,
  },
  reducers: {
    clearStatisticsState: (state) => {
      state.message = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createStatistics.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.message = "Statistics created successfully";
      })
      .addCase(createStatistics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchStatisticsByUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchStatisticsByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchStatisticsByUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateStatistics.fulfilled, (state, action) => {
        state.data = action.payload;
        state.message = "Statistics updated successfully";
      })
      .addCase(fetchExtendedStatisticsByUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchExtendedStatisticsByUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchExtendedStatisticsByUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })      
      .addCase(deleteStatistics.fulfilled, (state, action) => {
        if (state.data && state.data.user_id === action.payload) {
          state.data = null;
        }
        state.message = "Statistics deleted successfully";
      });
  },
});

export const { clearStatisticsState } = statisticsSlice.actions;
export default statisticsSlice.reducer;